import React, { useState, useEffect, useMemo } from 'react';
import { Card } from '../../components/ui/Card';
import { Loader2, Mail, ExternalLink, AlertCircle } from 'lucide-react';
import { WUNDER_BRAND_ID } from '../../config/brandGroups';

// Wunder · marka planları takibi (yalnız Efe). ASICS / adidas / Salomon'a bu yıl gönderilen
// planlar, mail kayıtları, anlaşma notları ve plan ↔ gerçekleşen aylık harcama.
// Plan ve mail kayıtları elle tutuluyor (kaynak: efe@heyglowy.com Gmail, 21 Eki 2026 taraması);
// yeni plan/rapor gidince BRANDS dizisine ekle. Gerçekleşen harcama canlı: kampanya adında
// marka geçen Google + Meta kampanyaları (/api/brand-campaign-report/monthly-spend).

const API = 'https://api.glowytics.com';
const YEAR_START = '2026-02-01';
const MONTHS_TR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const tl = (n) => (n == null ? '-' : `₺${Math.round(Number(n)).toLocaleString('tr-TR')}`);
const tlK = (n) => (!n ? '-' : `₺${(Number(n) / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 1 })}K`);
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const monthLabel = (m) => `${MONTHS_TR[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;

// plan: ay → [Google, Meta] (₺). null = o ay plan dışı.
const BRANDS = [
  {
    key: 'asics',
    name: 'ASICS',
    contact: 'Nurcan Şen (ASICS) · Wunder tarafı Emir Romi, Emrah Ertuğrul',
    reportPage: '/reports/asics-eylul',
    plans: [
      {
        title: 'Always-On Performans Planı · Şubat–Aralık 2026',
        total: 1100000,
        split: 'Google ₺440K (%40: Search 160K, PMax 200K, Demand Gen 80K) · Meta ₺660K (%60: Advantage+ 260K, Reach 220K, Traffic 180K)',
        notes: [
          'İndirimli ürünler plan dışı.',
          '18 Şub Nurcan: Aralık çıkarılsın (herkes indirimde, yeni ürün yok) → toplam ₺1M\'de el sıkışıldı.',
          'Nurcan: "kesinlikle indirim konuşmak istemiyoruz"; rekabette diğer kanallarla çakışılmasın.',
          'Emir: fatura 1.000.000 TL + KDV tek seferde, 90 gün vade, cari mahsup değil ayrı ödeme.',
        ],
      },
    ],
    plan: {
      '2026-02': [36000, 54000], '2026-03': [38000, 57000], '2026-04': [38000, 57000], '2026-05': [38000, 57000],
      '2026-06': [32000, 48000], '2026-07': [30000, 45000], '2026-08': [32000, 48000], '2026-09': [42000, 63000],
      '2026-10': [52000, 78000], '2026-11': [54000, 81000], '2026-12': null,
    },
    planNote: 'Aralık (₺120K) 18 Şub\'da plandan çıkarıldı.',
    mails: [
      { date: '2026-02-10', who: 'Efe → Emir', subject: 'Asics Always on planı', note: 'Plan tablosu (₺1,1M, Şub–Ara).' },
      { date: '2026-02-16', who: 'Emir → Nurcan (ASICS)', subject: 'Asics Always on planı', note: 'Plan ASICS\'e iletildi; 18 Şub Aralık çıktı, ₺1M.' },
      { date: '2026-03-13', who: 'Efe → Emir', subject: 'Asics Şubat Raporu', kind: 'rapor' },
      { date: '2026-03-25', who: 'Efe → Emir', subject: 'Asics 2026 Şubat', kind: 'rapor' },
      { date: '2026-04-10', who: 'Emir → Efe', subject: 'Fwd: Asics Dijital Pazarlama faturası hk.', note: 'Fatura yazışması.' },
      { date: '2026-04-27', who: 'Efe → Emir', subject: 'Asics Nisan 2026 Raporu', kind: 'rapor' },
      { date: '2026-06-02', who: 'Efe → Emir', subject: 'Asics Mayıs 2026 Raporu', kind: 'rapor' },
      { date: '2026-09-01', who: 'Efe → Emir', subject: 'Asics Ağustos Raporu', kind: 'rapor', note: 'Harcama + sitedeki toplam ASICS satışı (2 görsel).' },
      { date: '2026-10-08', who: 'Barış → Emir, Emrah', subject: 'Wunder // Eylül Ayı Performans Özeti Hakkında', kind: 'rapor', note: 'Genel Wunder raporu; ASICS yalnız marka/kampanya satırı.' },
      { date: '2026-10-21', who: 'Nurcan → Wunder (Berke, Emrah…)', subject: 'Geçen ay sonuçları + collab', note: 'Eylül sonuçları; collab\'larda sold out yok; Carnan + Above The Clouds için sosyal medya/e-mailing desteği.', kind: 'talep' },
      { date: '2026-10-21', who: 'Efe → Emir', subject: 'Asics Eylül Raporu', kind: 'rapor', note: 'PDF (Wunder_ASICS_Eylul_2026): harcama ₺109,2K, ROAS 9,14x, wunder.com.tr ₺1,92M. 8 Eki raporunda Google ₺36,9K yazıyordu.' },
    ],
    open: [
      'Eylül raporu 21 Eki Emir\'e gitti; Nurcan\'a iletilip iletilmediği takip edilecek.',
      'Mart, Haziran, Temmuz adıyla ayrı ASICS rapor maili bulunamadı.',
      'Carnan + Above The Clouds sosyal medya / e-mailing desteği (Wunder ekibi).',
    ],
  },
  {
    key: 'adidas',
    name: 'adidas',
    contact: 'İrem Deniz Tufanoğlu (adidas) · SFTM: Linzi Varon (adidas Trade Marketing) · Wunder tarafı Emir Romi',
    reportPage: '/reports/adidas-fw26',
    plans: [
      {
        title: 'Always-On Kampanya Planı · Şubat–Haziran 2026',
        total: 750000,
        split: 'Aylık ₺150K: Google ₺45K (%30: Search 15K, PMax 20K, Demand Gen 10K) · Meta ₺105K (%70: Advantage+ 40K, Reach 35K, Traffic 30K)',
        notes: [
          '20 Şub İrem: ayrı ödeme yok, "her zaman olduğu gibi mahsuplaşarak" devam.',
          'İrem\'in takip dosyası (SharePoint "Wunder Adidas SS26 Always on.xlsx") her ay gerçekleşenle doldurulacak; total e-ticaret satışı Wunder ekibinden.',
          'Efe 25 Mar: Şubat\'ta fiilen ~₺75K, Mart\'ta ₺150K bütçe vardı.',
          'Haziran sonrası (Temmuz–Aralık) için gönderilmiş plan yok.',
        ],
      },
    ],
    plan: {
      '2026-02': [45000, 105000], '2026-03': [45000, 105000], '2026-04': [45000, 105000],
      '2026-05': [45000, 105000], '2026-06': [45000, 105000],
    },
    mails: [
      { date: '2026-02-10', who: 'Efe → Emir', subject: 'Adidas Şubat - Haziran Plan', note: 'Plan tablosu (₺150K/ay).' },
      { date: '2026-02-18', who: 'İrem (adidas) ↔ Emir', subject: 'Adidas Always-On Kampanya Planı (Şubat - Haziran 2026)', note: 'Plan adidas\'a gitti; ödeme mahsuplaşarak.' },
      { date: '2026-03-11', who: 'Efe → Emir', subject: 'Şubat Ayı Adidas Reklamlar', kind: 'rapor', note: 'Şubat adidas kampanyaları + BAPE raporu (Şub–Mar).' },
      { date: '2026-03-25', who: 'Efe → Emir', subject: 'Re: Adidas Always-On Kampanya Planı', kind: 'rapor', note: 'İrem\'in istediği tablo; 30 Mar reach eklenmiş hali.' },
      { date: '2026-04-01', who: 'Efe → Emir', subject: 'Re: Adidas Always-On Kampanya Planı', kind: 'rapor', note: 'Mart raporu.' },
      { date: '2026-05-04', who: 'Efe → Emir', subject: 'Re: Adidas Always-On Kampanya Planı', kind: 'rapor', note: 'Nisan raporu; İrem\'in dosyasına da girildi.' },
      { date: '2026-10-16', who: 'Linzi (adidas) → Emir', subject: 'Song For The Mute // Adidas HK.', note: 'SFTM lansman videosu (mağaza projeksiyonu).' },
      { date: '2026-10-20', who: 'Wunder → Glowy', subject: 'FW26 Temmuz–Ağustos–Eylül datası', note: 'FW26 Tem–Eyl datası; Ekim\'de hangi ürünlerle devam; SFTM öne çıkarılsın.', kind: 'talep' },
      { date: '2026-10-21', who: 'Efe → Emir', subject: 'Adidas FW26 Ağustos - Eylül Raporu', kind: 'rapor', note: 'PDF: harcama ₺303,8K, ROAS 7,10x, wunder.com.tr ₺7,96M (Temmuz hariç).' },
    ],
    open: [
      'Mayıs ve Haziran raporu maili bulunamadı.',
      'FW26 raporu 21 Eki gönderildi (Ağu–Eyl; Temmuz istenmişti, dahil edilmedi).',
      'SFTM lansman ürünlerinin reklamda öne çıkarılması (Wunder/ekip).',
    ],
  },
  {
    key: 'salomon',
    name: 'Salomon',
    contact: 'Wunder tarafı Emir Romi · Salomon kontağı mailde yok',
    reportPage: '/reports/salomon-eylul',
    plans: [
      {
        title: 'Salomon × Wunder teklifi · Eylül–Kasım 2026',
        total: 450000,
        link: '/budget/salomon-wunder-eylul-kasim-2026',
        split: 'Aylık ₺150K medya: Meta ₺90K + Google ₺60K · ana sayfa First Banner (₺45K) + e-posta (₺35K) üstü çizili dahil',
        notes: [
          'Teklif sayfası 11 Ağu kuruldu, 12 Ağu sadeleşti; kurgu katalog tabanlı, video yok.',
          'Gönderim maili bulunamadı — kime, ne zaman gittiği kayıtlı değil.',
          'Kampanyalar 7 Eyl\'de başladı, yalnız Meta (Salomon adlı Google kampanyası yok).',
        ],
      },
    ],
    plan: { '2026-09': [60000, 90000], '2026-10': [60000, 90000], '2026-11': [60000, 90000] },
    mails: [
      { date: '2026-10-21', who: 'Efe → Emir', subject: 'Salomon Eylül Raporu', kind: 'rapor', note: 'PDF: Meta harcama ₺153,5K, ROAS 5,89x.' },
    ],
    open: ['Google tarafında Salomon kampanyası açılmadı (planda ₺60K/ay).', 'Teklifin Salomon\'a gönderim maili bulunamadı.'],
  },
];

function useMonthlySpend() {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/api/brand-campaign-report/monthly-spend?likes=${BRANDS.map((b) => b.key).join(',')}&startDate=${YEAR_START}&endDate=${ymd(new Date())}`,
      { credentials: 'include', headers: { 'X-Brand-ID': WUNDER_BRAND_ID } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('Harcama verisi alınamadı'))))
      .then((j) => { if (!cancelled) setState({ loading: false, data: j.spend, error: null }); })
      .catch((e) => { if (!cancelled) setState({ loading: false, data: null, error: e.message }); });
    return () => { cancelled = true; };
  }, []);
  return state;
}

const KIND_STYLE = {
  rapor: 'bg-blue-50 text-blue-700',
  talep: 'bg-amber-50 text-amber-800',
  plan: 'bg-emerald-50 text-emerald-700',
};
const KIND_LABEL = { rapor: 'Rapor', talep: 'Talep', plan: 'Plan' };

function PlanVsActual({ brand, spend }) {
  const thisMonth = ymd(new Date()).slice(0, 7);
  const rows = useMemo(() => {
    const months = new Set([...Object.keys(brand.plan), ...Object.keys(spend || {})]);
    return [...months].filter((m) => m >= YEAR_START.slice(0, 7)).sort().map((m) => {
      const p = brand.plan[m];
      const a = spend?.[m] || { google: 0, meta: 0 };
      const planTotal = p ? p[0] + p[1] : null;
      const actual = a.google + a.meta;
      return { m, p, a, planTotal, actual, future: m > thisMonth, current: m === thisMonth };
    });
  }, [brand, spend, thisMonth]);
  const done = rows.filter((r) => r.p && !r.future && !r.current);
  const sumPlan = done.reduce((s, r) => s + r.planTotal, 0);
  const sumAct = done.reduce((s, r) => s + r.actual, 0);
  const th = 'py-2.5 px-2.5 text-right font-semibold text-gray-600 first:text-left whitespace-nowrap text-xs';
  const td = 'py-2 px-2.5 text-right text-gray-700 whitespace-nowrap';

  return (
    <div>
      <div className="overflow-x-auto rounded-xl border border-gray-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50/80 border-b border-gray-200">
              <th className={th}>Ay</th>
              <th className={th}>Plan Google</th>
              <th className={th}>Plan Meta</th>
              <th className={th}>Plan</th>
              <th className={th}>Gerç. Google</th>
              <th className={th}>Gerç. Meta</th>
              <th className={th}>Gerçekleşen</th>
              <th className={th}>Plana göre</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((r) => {
              const pct = r.planTotal ? r.actual / r.planTotal : null;
              const tone = pct == null ? 'text-gray-400' : pct < 0.7 ? 'text-red-600' : pct > 1.15 ? 'text-amber-600' : 'text-emerald-600';
              return (
                <tr key={r.m} className={r.future ? 'bg-gray-50/40 text-gray-400' : 'bg-white'}>
                  <td className="py-2 px-2.5 text-left font-medium text-gray-800 whitespace-nowrap">
                    {monthLabel(r.m)}{r.current && <span className="ml-1.5 text-[10px] text-blue-600 font-medium">devam ediyor</span>}
                  </td>
                  <td className={td}>{r.p ? tlK(r.p[0]) : '-'}</td>
                  <td className={td}>{r.p ? tlK(r.p[1]) : '-'}</td>
                  <td className={td + ' font-medium text-gray-800'}>{r.p ? tlK(r.planTotal) : <span className="text-gray-400">plan yok</span>}</td>
                  <td className={td}>{r.future ? '' : tlK(r.a.google)}</td>
                  <td className={td}>{r.future ? '' : tlK(r.a.meta)}</td>
                  <td className={td + ' font-medium text-gray-800'}>{r.future ? '' : tlK(r.actual)}</td>
                  <td className={`${td} font-medium ${tone}`}>{r.future || pct == null ? '' : `%${Math.round(pct * 100)}`}</td>
                </tr>
              );
            })}
          </tbody>
          {done.length > 0 && (
            <tfoot>
              <tr className="bg-gray-100 font-bold text-gray-800 border-t border-gray-200">
                <td className="py-2.5 px-2.5 text-left" colSpan={3}>Biten planlı aylar</td>
                <td className="py-2.5 px-2.5 text-right">{tlK(sumPlan)}</td>
                <td colSpan={2} />
                <td className="py-2.5 px-2.5 text-right">{tlK(sumAct)}</td>
                <td className="py-2.5 px-2.5 text-right">{sumPlan ? `%${Math.round((sumAct / sumPlan) * 100)}` : ''}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      {brand.planNote && <p className="mt-2 text-xs text-gray-500">{brand.planNote}</p>}
    </div>
  );
}

function BrandSection({ brand, spend, loading }) {
  return (
    <Card id={brand.key} className="p-6 rounded-3xl bg-white border border-gray-200/80 shadow-sm mb-6 scroll-mt-6">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-5">
        <div>
          <h2 className="text-xl font-semibold text-gray-800">{brand.name}</h2>
          <p className="text-sm text-gray-500 mt-0.5">{brand.contact}</p>
        </div>
        <a href={brand.reportPage} className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:underline">
          Rapor sayfası <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>

      {brand.plans.map((p) => (
        <div key={p.title} className="rounded-xl border border-emerald-200 bg-emerald-50/40 p-4 mb-5">
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <div className="font-semibold text-gray-800">
              {p.title}
              {p.link && <a href={p.link} className="ml-2 text-xs font-medium text-blue-600 hover:underline">teklif sayfası</a>}
            </div>
            <div className="text-lg font-semibold text-gray-800">{tl(p.total)}</div>
          </div>
          <div className="text-sm text-gray-600 mt-1">{p.split}</div>
          <ul className="mt-3 space-y-1 text-sm text-gray-700 list-disc pl-5">
            {p.notes.map((n) => <li key={n}>{n}</li>)}
          </ul>
        </div>
      ))}

      <h3 className="text-sm font-semibold text-gray-700 mb-2">Plan ↔ gerçekleşen harcama</h3>
      {loading ? (
        <div className="flex items-center justify-center py-8"><Loader2 className="w-5 h-5 animate-spin text-blue-500" /></div>
      ) : (
        <PlanVsActual brand={brand} spend={spend} />
      )}

      <div className="grid lg:grid-cols-3 gap-5 mt-6">
        <div className="lg:col-span-2">
          <h3 className="text-sm font-semibold text-gray-700 mb-2">Gönderilenler ve yazışmalar</h3>
          {brand.mails.length === 0 ? (
            <div className="p-3 rounded-lg bg-gray-50 text-gray-600 text-sm">Bu marka için mail kaydı bulunamadı.</div>
          ) : (
            <ol className="relative border-l border-gray-200 ml-1.5">
              {brand.mails.map((m) => (
                <li key={m.date + m.subject} className="ml-4 pb-3">
                  <span className="absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full bg-gray-300" />
                  <div className="flex flex-wrap items-center gap-2 text-xs text-gray-500">
                    <span className="font-medium text-gray-700">{new Date(m.date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' })}</span>
                    <span>{m.who}</span>
                    {m.kind && <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${KIND_STYLE[m.kind]}`}>{KIND_LABEL[m.kind]}</span>}
                  </div>
                  <div className="text-sm text-gray-800 flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />{m.subject}</div>
                  {m.note && <div className="text-xs text-gray-500 mt-0.5">{m.note}</div>}
                </li>
              ))}
            </ol>
          )}
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-700 mb-2">Açık konular</h3>
          <ul className="space-y-2">
            {brand.open.map((o) => (
              <li key={o} className="flex gap-2 text-sm text-gray-700 rounded-lg border border-amber-200 bg-amber-50/60 p-2.5">
                <AlertCircle className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />{o}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
}

export default function WunderPlanTakip() {
  const { loading, data, error } = useMonthlySpend();

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">Wunder · Marka Planları</h1>
          <p className="text-sm text-gray-500 mt-1">ASICS, adidas ve Salomon'a 2026'da gönderilen planlar, yazışmalar ve plana karşı gerçekleşen harcama</p>
        </div>
        <div className="inline-flex rounded-lg border border-gray-200 p-0.5 text-xs bg-white">
          {BRANDS.map((b) => (
            <a key={b.key} href={`#${b.key}`} className="px-3 py-1.5 rounded-md font-medium text-gray-600 hover:bg-gray-100">{b.name}</a>
          ))}
        </div>
      </div>
      {error && <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm">{error}</div>}
      {BRANDS.map((b) => <BrandSection key={b.key} brand={b} spend={data?.[b.key]} loading={loading} />)}
      <p className="text-xs text-gray-400">
        Gerçekleşen = kampanya adında marka adı geçen Google Ads + Meta kampanyalarının harcaması (genel katalog/PMax/DSA kampanyalarındaki marka payı dahil değil).
        Markaya gönderilen raporlardaki rakamlarla birebir aynı olmayabilir. Plan ve mail kayıtları 21 Eki 2026'da Gmail'den derlendi.
      </p>
    </div>
  );
}
